import { Box, chakra, Flex } from "@chakra-ui/react";
export const StatContainer = chakra(Box, {
  baseStyle: {
    minW: "200px",
    height: "190px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    boxShadow: "sm",
    borderRadius: "15px",
  },
});

export const CenterContainer = chakra(Flex, {
  baseStyle: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    align: "center",
    gap: "2",
    mb: "2",
  },
});
